export function getLocalPartOfEmail(email: string) {
  const lastIndexOfLocalPart = email.indexOf('@');
  if (lastIndexOfLocalPart < 0) {
    console.warn('Not an email', email);
    return email;
  }
  const localPart = email.slice(0, lastIndexOfLocalPart).toUpperCase();
  return localPart.slice(0, 3);
}
